import React, { useEffect, useRef } from 'react';

export default function DemoPage() {
    const calendlyRef = useRef(null);

    useEffect(() => {
        // Load Calendly script only once
        const scriptId = 'calendly-widget-script';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://assets.calendly.com/assets/external/widget.js';
            script.async = true;
            document.body.appendChild(script);
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-logo-first/10 to-logo-third/10 py-12 px-4">
            <div className="w-full max-w-3xl bg-white rounded-xl shadow-2xl p-6">
                <h2 className="text-3xl font-bold text-logo-first mb-6 text-center">Book a Demo</h2>
                <div
                    ref={calendlyRef}
                    className="calendly-inline-widget"
                    data-url="https://calendly.com/milantheman23?hide_landing_page_details=1"
                    style={{ minWidth: 320, height: 700 }}
                ></div>
            </div>
        </div>
    );
}
